function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAviadevRealEstateLogo = function SvgAviadevRealEstateLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M113.7 148.4h5.4l1.4 28.6h40.9L135 107.5H99.5L67.6 177h43.7l2.4-28.6Zm2.2-27.7h1.7l.1 2.5h-2.1l.3-2.5Zm-.3 3.8h2.2l.2 4.5h-2.8l.4-4.5Zm-.5 7h3.1l.5 10.2h-4.5l.9-10.2Z",
    style: {
      fill: "#818181",
      fillRule: "nonzero"
    },
    transform: "matrix(.43443 0 0 .43973 .333 6.65)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9 61.6 142.7 70c-4.1.4-8.1.4-12.2 0l-2.8-.2-3.3-20.2-.2-1.4 32.3-7.2c.6-.1 1.1-.6 1.2-1.3l.3-1c0-.2-.1-.3-.2-.3L124.7 42c-.7.1-1.9.1-2.9.1-1.1 0-2-.9-2.1-2l-1.6-38.5c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3l-1.6 38.5c0 1.1-1 2-2.1 2-1 0-2.1 0-2.9-.1l-33.1-3.6c-.1 0-.3.1-.2.3l.3 1c.2.7.6 1.2 1.2 1.3l32.3 7.2-.2 1.4-3.3 20.2-2.9.2c-4.1.4-8.1.3-12.2 0L.6 61.6c-.4 0-.7.3-.6.7l.7 2.4c.5 1.6 1.7 2.7 3.3 3l70 13.5c-1.8 1.6-3 3.9-3.1 6.5-.1 4.8 3.8 8.9 8.5 9 5 .1 9-3.9 9-8.8 0-1.5-.4-2.9-1-4.1l13.3 2.6c1.3.2 2.6.6 3.8 1.1l1.8.7.1.4c.6 1.7.9 3.6 1.5 5.3 1.6 5.1 4.4 7.3 8.8 7.3s7.2-2.2 8.8-7.3c.6-1.8.9-3.6 1.5-5.3l.1-.4 1.8-.7c1.2-.5 2.5-.8 3.8-1.1l13.3-2.6c-.7 1.3-1 2.7-1 4.2.1 4.7 3.9 8.6 8.6 8.7 5 .1 9-3.9 9-8.8 0-2.7-1.2-5.1-3.1-6.7l69.9-13.4c1.6-.3 2.9-1.5 3.3-3l.7-2.4c.2-.4-.1-.8-.5-.8Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(.43443 0 0 .43973 .333 6.65)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#645f5a",
      fillRule: "nonzero"
    },
    d: "M722.123 40.803h1.289v73.01h-1.289z",
    transform: "matrix(.59257 0 0 1.28902 -310.485 -51.786)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.408 58.007h3.271l.421-1.454h2.879l.436 1.454h3.328l-3.517-10.233h-3.3l-3.518 10.233Zm4.376-3.78.756-2.645.77 2.645h-1.526ZM746.483 58.065h3.111l3.43-10.233h-3.372l-1.584 5.654-1.585-5.654h-3.43l3.43 10.233ZM753.888 47.832h3.14v10.175h-3.14zM757.791 58.007h3.27l.422-1.454h2.878l.436 1.454h3.329l-3.518-10.233h-3.299l-3.518 10.233Zm4.375-3.78.756-2.645.77 2.645h-1.526ZM768.96 58.007h3.343c3.649 0 5.48-2.006 5.48-5.03v-.218c0-3.023-1.802-4.927-5.407-4.927h-3.416v10.175Zm3.503-7.399c1.294 0 2.137.596 2.137 2.209v.204c0 1.599-.843 2.209-2.137 2.209h-.363v-4.622h.363ZM779.054 58.007h7.529v-2.675h-4.418v-1.221h4.026v-2.442h-4.026v-1.163h4.346v-2.674h-7.457v10.175ZM790.659 58.065h3.111l3.43-10.233h-3.372l-1.584 5.654-1.585-5.654h-3.43l3.43 10.233Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(2.28478 0 0 2.2848 -1541.825 -86.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062 0h.194v-.212h.085L.482 0h.224L.539-.244a.221.221 0 0 0 .144-.215v-.002a.217.217 0 0 0-.062-.163C.574-.672.5-.7.393-.7H.062V0Zm.194-.364v-.168h.127c.065 0 .105.028.105.083v.002c0 .051-.038.083-.104.083H.256Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 133.962 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062 0H.63v-.165H.254v-.111H.59v-.153H.254v-.106h.371V-.7H.062V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 148.728 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 0H.21l.05-.125h.27L.581 0h.208L.491-.705H.304L.006 0Zm.311-.276.079-.199.078.199H.317Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 162.744 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062 0h.533v-.17H.256V-.7H.062V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 178.613 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062 0H.63v-.165H.254v-.111H.59v-.153H.254v-.106h.371V-.7H.062V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 200.249 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.337.012c.17 0 .283-.085.283-.228v-.002c0-.131-.1-.183-.261-.218C.262-.458.238-.472.238-.504v-.002c0-.025.023-.045.07-.045.062 0 .132.024.196.069l.097-.137a.44.44 0 0 0-.288-.093c-.168 0-.271.094-.271.224v.002c0 .144.115.186.264.22.095.022.118.038.118.067v.002c0 .03-.028.048-.08.048a.36.36 0 0 1-.227-.084l-.108.129a.489.489 0 0 0 .328.116Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 214.265 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.233 0h.194v-.53h.21V-.7H.023v.17h.21V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 227.77 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 0H.21l.05-.125h.27L.581 0h.208L.491-.705H.304L.006 0Zm.311-.276.079-.199.078.199H.317Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 240.383 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.233 0h.194v-.53h.21V-.7H.023v.17h.21V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 254.948 67.315)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.062 0H.63v-.165H.254v-.111H.59v-.153H.254v-.106h.371V-.7H.062V0Z",
    style: {
      fill: "#0091ff",
      fillRule: "nonzero"
    },
    transform: "matrix(14.49271 0 0 14.49276 268.859 67.315)"
  }));
};

export default SvgAviadevRealEstateLogo;